import * as yup from "yup";

const schema = yup.object().shape({
    nome: yup.string().required("Campo obrigatório"),
    inscricao: yup.string().required("Campo obrigatório"),
    Cidade: yup.object().required("Campo obrigatório").shape({
        value: yup.number().required("Campo obrigatório"),
        label: yup.string()
    }),
    endereco: yup.string().required("Campo obrigatório"),
    cep: yup.string().required("Campo obrigatório"),
    uf: yup.string().required("Campo obrigatório"),
});

const defaultValues = {
    codigoResponsavel: 0,
    numero: 0,
    bairro: " ",
    nomeRepresentante: "",
    cpfRepresentante: "",
    numeroTermoAutorizacao: 0,
    dataAto: new Date(),
    processoAnatel: "",
    numeroContrato: "",
    situacao: 0,
    cadastradoPorAnalista: false
}

export { defaultValues, schema }